import React from 'react';
import { Link } from 'react-router-dom';

import BG4 from '../assets/img/bg-4.png';


const QuickPoint = (props) => {
    return (
        <section className="quick-sec">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="quick-inner">
                            <img src={BG4} alt="" className="w-100" />
                            <div className="quickList">

                                <div className="row">
                                    {props.text &&
                                        <div className="col-12">
                                            <h5 className="heading-1fff text-white text-center" data-aos="fade-up">{props.text}<br />
                                                <Link href={`tel:${props.phoneNo}`} className="text-reset text-decoration-none">{props.phoneNo}</Link>
                                            </h5>
                                        </div>
                                    }
                                    {props.point1Text &&
                                        <div className="col-md-4">
                                            <div className="quick-box" data-aos="fade-up" data-aos-duration={1500}>
                                                <img src={props.point1Icon} alt="" />
                                                <p>{props.point1Text}</p>
                                            </div>
                                        </div>
                                    }
                                    {props.point2Text &&
                                        <div className="col-md-4">
                                            <div className="quick-box" data-aos="fade-up" data-aos-duration={2500}>
                                                <img src={props.point2Icon} alt="" />
                                                <p>{props.point2Text}</p>
                                            </div>
                                        </div>
                                    }
                                    {props.point3Text &&
                                        <div className="col-md-4">
                                            <div className="quick-box" data-aos="fade-up" data-aos-duration={3000}>
                                                <img src={props.point3Icon} alt="" />
                                                <p>{props.point3Text}</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuickPoint;